import { Badge, Button, Card, List, Popconfirm, Radio } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

import { OpportunityState } from "components/opportunity-state";
import { OpportunityStateModal } from "./modals/opportunity-state";
import { OpportunityStatesOrder } from "./opportunity-states-order";
import { colors } from "@evolved/constants";
import { useModal } from "hooks/use-modal";
import {
  useArchiveOpportunityState,
  useOpportunityStates,
  useUpdateOpportunityState,
} from "data/use-opportunity-states";

const { PRIMARY } = colors;

const SYSTEM_KEY_NONE = "NONE";

const systemKeyToValue = (systemKey) => {
  if (systemKey === "WON") return "WON";
  if (systemKey === "LOST") return "LOST";

  return SYSTEM_KEY_NONE;
};

const Header = ({ opportunityStates, openOpportunityStateModal }) => {
  return (
    <div style={{ alignItems: "center", display: "flex", width: "100%" }}>
      <Badge
        count={opportunityStates.length}
        showZero
        style={{ backgroundColor: PRIMARY }}
      />
      <span style={{ marginLeft: "16px" }}>Opportunity Stages</span>
      <div
        style={{ marginLeft: "auto", marginRight: "16px" }}
      >
        <OpportunityStatesOrder />
      </div>
      <Button
        ghost
        onClick={() => openOpportunityStateModal()}
        type="primary"
      >
        <PlusCircleOutlined style={{ margin: "0px" }} />
      </Button>
    </div>
  );
};

export const OpportunityStates = () => {
  const { modal, open } = useModal(OpportunityStateModal);

  const archiveOpportunityState = useArchiveOpportunityState();
  const updateOpportunityState = useUpdateOpportunityState();
  const opportunityStates = useOpportunityStates().all({
    includeArchived: false,
  });

  return (
    <>
      {modal}
      <Card bordered={false} bodyStyle={{ paddingTop: "0px" }}>
        <List
          dataSource={opportunityStates}
          header={
            <Header
              {...{ opportunityStates, openOpportunityStateModal: open }}
            />
          }
          itemLayout={"vertical"}
          pagination={{
            pageSize: 5,
          }}
          renderItem={(opportunityState) => {
            const { _id, description } = opportunityState;

            let label = opportunityState.label;

            if (
              opportunityState.isSystem &&
              opportunityState.systemLabel !== label
            ) {
              label = `${label} (${opportunityState.systemLabel})`;
            }

            return (
              <List.Item key={_id}>
                <div style={{ alignItems: "center", display: "flex" }}>
                  <div>
                    <OpportunityState
                      showFunnelProgress={false}
                      opportunity={{
                        stateId: _id,
                      }}
                      style={{ marginLeft: "0px", marginBottom: "8px" }}
                    />
                    {opportunityState.isSystem && (
                      <div style={{ color: "rgba(0, 0, 0, 0.45)" }}>
                        System Stage
                      </div>
                    )}
                    {description && (
                      <div style={{ color: "rgba(0, 0, 0, 0.45)" }}>
                        {description}
                      </div>
                    )}
                    {!opportunityState.isSystem && (
                      <div style={{ marginTop: "8px" }}>
                        <Radio.Group
                          size="small"
                          optionType="button"
                          buttonStyle="solid"
                          value={systemKeyToValue(opportunityState.systemKey)}
                          onChange={(e) =>
                            updateOpportunityState.mutate({
                              id: opportunityState._id,
                              systemKey:
                                e.target.value === SYSTEM_KEY_NONE
                                  ? null
                                  : e.target.value,
                            })
                          }
                          options={[
                            { label: "Won", value: "WON" },
                            { label: "Lost", value: "LOST" },
                            { label: "None", value: SYSTEM_KEY_NONE },
                          ]}
                        />
                      </div>
                    )}
                  </div>
                  <div style={{ marginLeft: "auto" }}>
                    <span
                      className="primary-clickable"
                      onClick={() => open({ opportunityState })}
                    >
                      Update
                    </span>
                  </div>

                  {!opportunityState.isSystem && (
                    <>
                      <div style={{ margin: "0px 8px" }}>|</div>
                      <Popconfirm
                        okText="Yes"
                        onConfirm={() =>
                          archiveOpportunityState.mutateAsync({
                            id: opportunityState._id,
                          })
                        }
                        title="Are you sure?"
                      >
                        <span className="primary-clickable">Archive</span>
                      </Popconfirm>
                    </>
                  )}
                </div>
              </List.Item>
            );
          }}
        />
      </Card>
    </>
  );
};
